import * as ReactIs from "react-is"
import { postalCodeRegex, postalCodeRegexProps } from "./constants/postalCodeRegex"

export const isDefined = (obj: any) => {
	return typeof obj !== "undefined" && obj !== null
}

export const isNotEmpty = (obj: any) => {
	return typeof obj !== "undefined" && obj !== null && obj !== ""
}

export const isEmpty = (data: any) => {
	if (typeof data == "number" || typeof data == "boolean") return false
	if (typeof data == "undefined" || data === null) return true
	if (typeof data.length != "undefined") return data.length === 0
	return (
		// prettier-ignore
		data.reduce((acc: number, curr: number) => (data.hasOwnProperty(curr) ? acc++ : acc), 0) === 0
	)
}

export const isObject = (obj: any) => {
	return obj === Object(obj)
}

export const objectIsNotEmpty = (obj: Record<string, unknown>) => {
	return isNotEmpty(obj) && Object.keys(obj).length > 0
}

export const isReactElement = (obj: string | React.ReactElement) => {
	return ReactIs.isElement(obj)
}

export const isEmailValid = (str: string) => {
	// FIXME: explicit
	const reg = new RegExp(
		/^([a-zA-Z0-9_\-+.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{1,15}|[0-9]{1,3})(\]?)$/
	)
	return !(str.match(reg) === null)
}

export const isInt = (str: string) => {
	return /^[0-9]*$/.test(str)
}

export const isPasswordValid = (str: string) => {
	// FIXME: explicit
	const reg = new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z-,_;:@$!%*?&\W]{8,}$/)
	return !(str.match(reg) == null)
}

export const isPostalCodeValid = (str: string, countryCode = "FR") => {
	const reg = postalCodeRegex.find(
		(country: postalCodeRegexProps) => country.countryCode === countryCode
	)?.rule
	return !(str.match(reg) === null)
}
